import { render, staticRenderFns } from "./addImmediateAction.vue?vue&type=template&id=07a8c73e"
import script from "./addImmediateAction.vue?vue&type=script&lang=js"
export * from "./addImmediateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports